import { render, staticRenderFns } from "./folder.vue?vue&type=template&id=433c8bef&scoped=true&"
import script from "./folder.vue?vue&type=script&lang=js&"
export * from "./folder.vue?vue&type=script&lang=js&"
import style0 from "./folder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./folder.vue?vue&type=style&index=1&id=433c8bef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433c8bef",
  null
  
)

export default component.exports